import { Phone } from "lucide-react";

/** Sticky bottom bar for mobile with Call Now + Get Started CTAs. */
export const MobileStickyBar = ({ onGetStarted }) => (
  <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t border-gray-200 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] px-3 py-2 flex gap-2" data-testid="mobile-sticky-bar">
    <a
      href="tel:+19049559646"
      className="flex-1 flex items-center justify-center gap-2 bg-[#0F5132] text-white rounded-full py-3 font-semibold text-sm shadow"
      data-testid="sticky-call-btn"
    >
      <Phone className="w-4 h-4" />
      Call Now
    </a>
    <button
      onClick={onGetStarted}
      className="flex-1 flex items-center justify-center bg-[#EA580C] text-white rounded-full py-3 font-semibold text-sm shadow"
      data-testid="sticky-get-started-btn"
    >
      Get Started
    </button>
  </div>
);
